import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SEMANTIC, UI } from '../../styles/theme';

const BackButton = ({
  to,                 // route esplicita
  fallback = '/portfolio', // fallback di sicurezza
  label,
  onClick,            // handler custom (sovrascrive to/fallback)
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const buttonLabel = label !== undefined ? label : t('common.back');

  const handleBack = () => {
    if (onClick) {
      onClick();
    } else if (to) {
      navigate(to);
    } else {
      navigate(fallback);
    }
  };

  return (
    <div className="d-flex justify-content-end mb-4">
      <button
        onClick={handleBack}
        style={{
          background: 'transparent',
          border: 'none',
          color: SEMANTIC.textPrimary,
          fontSize: UI.fontSize.lg,
          fontWeight: UI.fontWeight.bold,
          display: 'flex',
          alignItems: 'center',
          gap: UI.spacing.sm,
          cursor: 'pointer',
        }}
      >
        <i
          className="bi bi-arrow-left-circle"
          style={{ fontSize: '26px' }}
        />
        {buttonLabel}
      </button>
    </div>
  );
};

export default BackButton;
